import React from "react";

function FlatIcon() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1010_41)">
        <path
          d="M26.6721 30.0986V28.1248C27.4282 27.771 27.9534 27.0032 27.9534 26.1145C27.9534 24.8911 26.958 23.8958 25.7346 23.8958C24.5112 23.8958 23.5159 24.8911 23.5159 26.1145C23.5159 27.0032 24.041 27.771 24.7971 28.1248V30.0986C22.9905 29.6736 21.6409 28.0493 21.6409 26.1145C21.6409 23.8572 23.4773 22.0208 25.7346 22.0208C26.0554 22.0208 26.3669 22.0591 26.6665 22.1292V6.3855H19.9473V30.1147H18.0723V2.66846H16.5503V0H3.70947V2.66846H2.1875V32L29.7917 31.9895V30.1145H26.6724V30.0986H26.6721ZM24.25 19.7395H22.375V17.0728H24.25V19.7395ZM24.25 14.4062H22.375V11.7395H24.25V14.4062ZM13.3958 17.073V19.7397H11.5208V17.073H13.3958ZM11.5208 14.4062V11.7395H13.3958V14.4062H11.5208ZM13.3958 22.4062V25.073H11.5208V22.4062H13.3958ZM13.3958 9.073H11.5208V6.40625H13.3958V9.073ZM6.854 6.40625H8.729V9.073H6.854V6.40625ZM6.854 11.7395H8.729V14.4062H6.854V11.7395ZM6.854 17.073H8.729V19.7397H6.854V17.073ZM6.854 22.4062H8.729V25.073H6.854V22.4062Z"
          fill="#3E64FF"
        />
      </g>
      <defs>
        <clipPath id="clip0_1010_41">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default FlatIcon;
